import Papa from "papaparse";

export const parseInput = (input: string): string[] => {
  if (!input.trim()) return [];

  try {
    const result = Papa.parse(input, {
      skipEmptyLines: true,
      delimiter: "", // Auto-detect delimiters
      quoteChar: '"',
      escapeChar: '"',
    });

    const flatValues = result.data
      .flat()
      .filter((value): value is string => typeof value === "string")
      .map((value) => value.trim())
      .filter(Boolean);

    const uniqueValues = new Set(flatValues);

    return Array.from(uniqueValues);
  } catch (error) {
    console.error("Error parsing input:", error);
    return [];
  }
};

export const formatForClipboard = (productCodes: string[]): string => {
  if (!productCodes.length) return "";

  return productCodes
    .map((code) => {
      const needsQuoting = /[\s,"';:|]/.test(code);

      if (needsQuoting) {
        const escaped = code.replace(/"/g, '""');
        return `"${escaped}"`;
      }

      return code;
    })
    .join("\n");
};
